import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Modal, Form, Image, Container } from 'react-bootstrap';
import '../Assets/css/header.css';
import { NavLink } from 'react-router-dom';
import { base_url } from '../Helpers/request';
import 'react-toastify/dist/ReactToastify.css';
import { Breadcrumbs, CircularProgress, TextField, Typography } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import { gapi } from 'gapi-script';

const ForgotPass = (props) => {
    const [errmsg2, setErrmsg2] = useState(false);
    const [msg, setMsg] = useState('');

    //forgotpass
    const [f_email, setF_email] = useState('');   
    useEffect(() => {
        gapi.load('client:auth2', () => {
            gapi.client.init({
                clientId: "549981789532-4bt0u9a45fujhv35ha0dil32bomr9221.apps.googleusercontent.com",
                plugin_name: "chat"
            })
        })
    }, [])
    const handleforgotpassword = (e) => {
        setButtonLoading(true);
        e.preventDefault();
        var data = {
            email: f_email
        }
        axios.post(base_url + '/user/forget_password', data, {
            headers: {
                // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.data.status == 1) {
                    setButtonLoading(false);
                    setF_email("");
                    window.location.href = '/login';
                    return swal(response.data.message, "", "success");
                } else {
                    setButtonLoading(false);
                    setErrmsg2(true)
                    setMsg(response.data.message)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const [buttonLoading, setButtonLoading] = useState(false)
    return (<>


        <Container className='mt-2'>
            <Row>
                <Col className="rcs_breadcrumb mb-2">
                    <Breadcrumbs aria-label="breadcrumb">
                        <NavLink underline="hover" color="inherit" to="/">
                            Home
                        </NavLink>
                        <Typography color="text.primary">Forgot Password</Typography>
                    </Breadcrumbs>
                </Col>
            </Row>
        </Container>

        <section className='Dfl_forgotPass_section'>
            <Container>
                <Row>
                    <Col lg={7} className="m-auto">


                        <div className="rcs_appointment_input rcs_login rcs_forgot">
                            <Modal.Title id="contained-modal-title-vcenter">Forgot Password</Modal.Title>
                            <div className="rcs_forgot_msg"><span>To reset your password, please enter your email address</span></div>
                            <Form onSubmit={handleforgotpassword}>
                                <Row>
                                    <Col>
                                        <TextField
                                            id="outlined-basic"
                                            label="Email Address"
                                            type="Email"
                                            variant="outlined"
                                            value={f_email}
                                            onChange={(e) => setF_email(e.target.value)}
                                            required />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={8} className="m-auto">
                                        <Button className="rcs_fill_button" type="submit" disabled={buttonLoading}>
                                            Continue {buttonLoading ? <CircularProgress className="rcs_loader" /> : ""}
                                        </Button>
                                    </Col>
                                </Row>
                                {errmsg2 ?
                                    <Row>
                                        <Col lg={10} className="m-auto">
                                            <div className="rcs_signup_link rcs_signup_link_error">
                                                <p style={{ color: "red" }}>{msg}</p>
                                            </div>
                                        </Col>
                                    </Row> : ""}
                                <Row>
                                    <Col lg={6} className="m-auto">
                                        <div className="rcs_signup_link">
                                            <p>Remember your password ? <NavLink to="/login">Login</NavLink></p>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>


                    </Col>
                </Row>
            </Container>
        </section>

    </>
    );
};

export default ForgotPass;